<template>
    <span class="pt-pagination__sizes">
        <pt-select
            :model-value="innerPageSize"
            :disabled="disabled"
            :popper-class="popperClass"
            size="mini"
            @change="handleChange"
        >
            <pt-option
                v-for="item in innerPagesizes"
                :key="item"
                :value="item"
                :label="item + t('pt.pagination.pagesize')"
            />
        </pt-select>
    </span>
</template>

<script lang="ts">
import { watch, computed, ref } from 'vue';
import PtSelect from '../../select';
import PtOption from '../../option';
import { t } from '../../locale';
import { isEqual } from 'lodash-es';
import { usePagination } from './usePagination';

export default {
    name: 'Sizes',
    components: {
        PtSelect,
        PtOption,
    },
    props: {
        pageSize: Number,
        pageSizes: {
            type: Array,
            default: () => {
                return [10, 20, 30, 40, 50, 100];
            },
        },
        popperClass: {
            type: String,
            default: '',
        },
        disabled: Boolean,
    },
    emits: ['page-size-change'],
    setup(props, { emit }) {
        const { pagination } = usePagination();
        const innerPageSize = ref<Nullable<number>>(props.pageSize);

        watch(
            () => props.pageSizes,
            (newVal, oldVal) => {
                if (isEqual(newVal, oldVal)) return;
                if (Array.isArray(newVal)) {
                    const pageSize = newVal.indexOf(props.pageSize) > -1 ? props.pageSize : props.pageSizes[0];
                    emit('page-size-change', pageSize);
                }
            },
        );

        watch(
            () => props.pageSize,
            (newVal) => {
                innerPageSize.value = newVal;
            },
        );

        const innerPagesizes = computed(() => props.pageSizes);

        function handleChange(val: number) {
            if (val !== innerPageSize.value) {
                innerPageSize.value = val;
                pagination?.handleSizeChange(Number(val));
            }
        }

        return {
            t,
            innerPagesizes,
            innerPageSize,
            handleChange,
        };
    },
};
</script>
